import * as types from "../action/ActionType";
import type { AppAction } from "../action/ActionType";

export default function EditReducer(state: boolean = false, action: AppAction): boolean {
  switch (action.type) {
    case types.TURN_FLAG:
      return action.payload;
    default:
      return state;
  }
}
